export default __webpack_public_path__ + "static/media/saibaba-newburgh6.d39d009c.jpg";